import React from 'react';
import ButtonsListContent from './buttons-list.content';
import { buttonListData } from '../buttons-list.data';

const ButtonsList: React.FunctionComponent = () => {
  return <ButtonsListContent items={buttonListData} />;
};

export default ButtonsList;
